import { SessionKit } from "@wharfkit/session"
import { WebRenderer } from "@wharfkit/web-renderer"
import { WalletPluginAnchor } from "@wharfkit/wallet-plugin-anchor"
import { WalletPluginCloudWallet } from "@wharfkit/wallet-plugin-cloudwallet"
import { WalletPluginScatter } from "@wharfkit/wallet-plugin-scatter"
import { WalletPluginWombat } from "@wharfkit/wallet-plugin-wombat"
import { APP_NAME, currentSelectedApi, userSelectedAnApi } from "./config"

const webRenderer = new WebRenderer({minimal: true})

export const sessionKit = new SessionKit({
    appName: APP_NAME,
    chains: [   
      {
        id: "1064487b3cd1a897ce03ae5b6a865651747e2e152090f99c1d19d44e01aea5a4",
        url: (userSelectedAnApi == null || !userSelectedAnApi) ? "https://api.waxdaobp.io" :
        currentSelectedApi
      },      
    ],
    ui: webRenderer,
    walletPlugins: [
        new WalletPluginAnchor(), 
        new WalletPluginCloudWallet(),
        new WalletPluginScatter(),
        new WalletPluginWombat()
    ],
  })

export const checkWharfLogin = async (setEnterModalText) => {
    let sessionString = localStorage.getItem("wharf--session");
if (
    sessionString == null
) {
    setEnterModalText(
    "You are not logged in. Click the wallet icon in the top menu"
    );
}
};


let session

export const logInWithWharfkit = async (setCurrentUser, setWharfSession) => {
    const response = await sessionKit.login()
    session = response.session
    let this_user = session.actor.toString();
    let wallet_provider = session.walletPlugin.id;
    setCurrentUser(this_user);
    localStorage.removeItem("wlstatus");
    localStorage.setItem("waxAccount", this_user);
    localStorage.setItem("walletProvider", wallet_provider);
    setWharfSession(session)
    location.reload();
}

export const logOutWharfkit = async (setCurrentUser, setWharfSession) => {
    await sessionKit.logout()
    session = undefined
    setCurrentUser("");
    localStorage.removeItem("waxAccount");
    localStorage.removeItem("walletProvider");
    localStorage.removeItem("wlstatus");
    setWharfSession(null)
    location.reload();
}

export const switchWharfAccount = async (newAccount, newPermission, newWalletProvider, setCurrentUser, setWharfSession) => {
    const existingSessions =
      JSON.parse(localStorage.getItem("wharf--sessions")) || [];

    const foundSession = existingSessions.find(
      (session) => session.actor === newAccount && session.permission === newPermission  && session.walletPlugin.id === newWalletProvider
    );

    if (!foundSession) return;

    localStorage.setItem("wharf--session", JSON.stringify(foundSession));

    localStorage.setItem("waxAccount", newAccount);
    localStorage.setItem("walletProvider", newWalletProvider);

    localStorage.removeItem("wlstatus");

    setCurrentUser(newAccount);
    setWharfSession(foundSession)

    location.reload();
}

export const removeWharfSession = (accountToRemove, permissionToRemove, walletProviderToRemove, setSessions) => {
    const existingSessions =
      JSON.parse(localStorage.getItem("wharf--sessions")) || [];

    const sessionIndex = existingSessions.findIndex(
      (session) => session.actor === accountToRemove && session.permission === permissionToRemove && session.walletPlugin.id === walletProviderToRemove
    );

    if (sessionIndex !== -1) {
      existingSessions.splice(sessionIndex, 1);
      localStorage.setItem("wharf--sessions", JSON.stringify(existingSessions));
    }

    fetchSessionsFromLocalStorage(setSessions)
}

export const fetchSessionsFromLocalStorage = (setSessions) => {
    const storedSessions = JSON.parse(localStorage.getItem("wharf--sessions")) || [];
    setSessions(storedSessions);
  };